import axios from 'axios';

export const baseURL = 'https://apidev.soba.africa/api/';
export const baseUrlPro = 'https://soba-api-v1.soba.africa/api/';

// const baseURL =
// 	window.location.hostname.includes("test") || window.location.hostname.includes("localhost")
// 		? baseUrlDev
// 		: baseUrlPro;

const instance = axios.create({
	baseURL: baseURL,
	timeout: 30000,
	headers: { 'Content-Type': 'application/json' },
	withCredentials: true
});

export const axiosPrivate = axios.create({
	baseURL: baseURL,
	timeout: 30000,
	headers: { 'Content-Type': 'application/json' },
	withCredentials: true
});

export default instance;
